<template>
  <div>
    <div>
      <ul class="dashboard__menu" id="menu">
        <li v-for="report in reports" :id="report.id" :data-test-name="report.displayName"
            class="dashboard__menu-li btn btn-primary mr-2" @click="reportClicked(report.id)">
          {{ report.displayName }}
        </li>
      </ul>
    </div>

    <div class="card">
      <section id="report-container"
               class="embed-container" style="height: calc((100vw - 60px) * 0.4);"></section>
    </div>
  </div>
</template>
<script>

import pbi from 'powerbi-client'
import 'bootstrap'
import { mapGetters } from 'vuex'
import { createReportLoadConfig } from '@/views/helpers/rsanalytics-helper'

export default {

  name: 'RsAnalytics',
  beforeRouteEnter (to, from, next) {
    next(vm => vm.$store.commit('breadcrumb/clear'))
  },
  beforeCreate () {
    this.$store.dispatch('analytics/fetch')
  },
  mounted () {
    this.loadReport()
  },
  computed: {

    ...mapGetters({ getDashboards: 'analytics/get' }),

    reports () {
      return this.getDashboards
    }

  },
  data () {
    return {
      reportClickedGAEventAction: 'RSAnalyticsUsage'
    }
  },
  methods: {
    reportClicked (reportId) {
      this.trackEvent(this.reportClickedGAEventAction, this.reportName(reportId))
      this.loadReport(reportId)
    },
    reportName (reportId) {
      return this.reports[reportId].displayName
    },
    loadReport: function (reportId = '0') {
      let reportContainer = document.getElementById('report-container')

      let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)

      // Request to get embed details
      this.$store.dispatch('rsAnalytics/fetch', { reportId: reportId })
        .then(embedInfo => {
          let reportLoadConfig = createReportLoadConfig(embedInfo, pbi.models.TokenType.Embed)

          // Use the token expiry to regenerate Embed token for seamless end user experience
          // Refer https://aka.ms/RefreshEmbedToken
          // let tokenExpiry = embedData["tokenExpiry"]

          powerbi.reset(reportContainer)
          // Embed Power BI report when Access token and Embed URL are available
          let report = powerbi.embed(reportContainer, reportLoadConfig)

          // Triggers when a report schema is successfully loaded
          report.on('loaded', function () {
            console.log('Report load successful')
          })

          // Triggers when a report is successfully embedded in UI
          report.on('rendered', function () {
            console.log('Report render successful')
          })

          // Clear any other error handler event
          report.off('error')
          // Below patch of code is for handling errors that occur during embedding
          report.on('error', function (event) {
            let errorMsg = event.detail

            // Use errorMsg letiable to log error in any destination of choice
            console.error(errorMsg)
          })
        })
    }
  }
}
</script>
